import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { DropdownList } from 'react-widgets';

import ErrorMessage from '../../../../components/text/ErrorMessage';
import { OneDriveSettingsData } from '../../../../core';

const UpdateForm: React.FunctionComponent<{
  onSubmit: (data: OneDriveSettingsData) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  data?: OneDriveSettingsData;
  error?: string;
}> = (props) => {
  const {
    control,
    handleSubmit,
    errors,
    watch,
  } = useForm<OneDriveSettingsData>({
    reValidateMode: 'onChange',
    mode: 'onSubmit',
    shouldUnregister: true,
    defaultValues: props.data,
  });

  const renderClientSecret = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Client Secret</label>
          <Controller
            control={control}
            rules={{
              required: 'Client Secret is required',
            }}
            name="clientSecret"
            defaultValue={props.data?.clientSecret}
            render={({ onChange, value, name }) => (
              <input
                type="password"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Client Secret"
                name={name}
                value={value}
                onChange={onChange}
                id="clientSecret"
              />
            )}
          />
          <ErrorMessage>{errors.clientSecret?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderUserEmail = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">User Email</label>
          <Controller
            control={control}
            rules={{
              required: 'Email is required',
              pattern: {
                value: /\S+@\S+\.\S+/,
                message: 'Enter a valid email',
              },
            }}
            name="userEmail"
            defaultValue={props.data?.userEmail}
            render={({ onChange, value, name }) => (
              <input
                type="email"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="User Email"
                name={name}
                value={value}
                onChange={onChange}
                id="userEmail"
              />
            )}
          />
          <ErrorMessage>{errors.userEmail?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderOrderInfoPath = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">
            Order Info Upload Path
          </label>
          <Controller
            control={control}
            rules={{
              required: 'Order Info upload path is required',
            }}
            name="orderInfoUploadPath"
            defaultValue={props.data?.orderInfoUploadPath}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Order Info Upload Path"
                name={name}
                value={value}
                onChange={onChange}
                id="orderInfoUploadPath"
              />
            )}
          />
          <ErrorMessage>{errors.orderInfoUploadPath?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderVehicleFileUploadPath = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">
            Vehicle File Upload Path
          </label>
          <Controller
            control={control}
            name="vehicleFileUploadPath"
            defaultValue={props.data?.vehicleFileUploadPath}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Vehicle File Upload Path"
                name={name}
                value={value}
                onChange={onChange}
                id="vehicleFileUploadPath"
              />
            )}
          />
        </div>
      </div>
    );
  };

  const renderAccessoriesInfoPath = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">
            Accessories Info Upload Path
          </label>
          <Controller
            control={control}
            rules={{
              required: 'Accessories Info upload path is required',
            }}
            name="accessoriesInfoUploadPath"
            defaultValue={props.data?.accessoriesInfoUploadPath}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Order Info Upload Path"
                name={name}
                value={value}
                onChange={onChange}
                id="accessoriesInfoUploadPath"
              />
            )}
          />
          <ErrorMessage>
            {errors.accessoriesInfoUploadPath?.message}
          </ErrorMessage>
        </div>
      </div>
    );
  };
  const renderPaymentInfoPath = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">
            Payment Info Upload Path
          </label>
          <Controller
            control={control}
            // rules={{
            //   required: 'Payment Info upload path is required',
            // }}
            name="paymentInfoUploadPath"
            defaultValue={props.data?.paymentInfoUploadPath}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Payment Info Upload Path"
                name={name}
                value={value}
                onChange={onChange}
                id="paymentInfoUploadPath"
              />
            )}
          />
          <ErrorMessage>{errors.paymentInfoUploadPath?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderClientId = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Client ID</label>
          <Controller
            control={control}
            rules={{
              required: 'Client ID is required',
            }}
            name="clientId"
            defaultValue={props.data?.clientId}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Client ID"
                name={name}
                value={value}
                onChange={onChange}
                id="clientId"
              />
            )}
          />
          <ErrorMessage>{errors.clientId?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderTenantId = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Tenant ID</label>
          <Controller
            control={control}
            rules={{
              required: 'Tenant ID is required',
            }}
            name="tenantId"
            defaultValue={props.data?.tenantId}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Tenant ID"
                name={name}
                value={value}
                onChange={onChange}
                id="tenantId"
              />
            )}
          />
          <ErrorMessage>{errors.tenantId?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderPaymentRequestType = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Payment Upload Type</label>
          <Controller
            control={control}
            name="paymentRequestType"
            defaultValue={props.data?.paymentRequestType || 'json'}
            render={({ onChange, value, name }) => (
              <DropdownList
                data={[
                  {
                    label: 'Api',
                    value: 'api',
                  },
                  {
                    label: 'JSON',
                    value: 'json',
                  },
                ]}
                id="paymentRequestType"
                placeholder="Payment Upload Type"
                name={name}
                value={value}
                onChange={(val) => onChange(val.value)}
                textField="label"
                valueField="value"
              />
            )}
          />
          <ErrorMessage>{errors.paymentRequestType?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderInvoiceRequestType = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Invoice Upload Type</label>
          <Controller
            control={control}
            name="invoiceRequestType"
            defaultValue={props.data?.invoiceRequestType || 'json'}
            render={({ onChange, value, name }) => (
              <DropdownList
                data={[
                  {
                    label: 'Api',
                    value: 'api',
                  },
                  {
                    label: 'JSON',
                    value: 'json',
                  },
                ]}
                id="invoiceRequestType"
                placeholder="Invoice Upload Type"
                name={name}
                value={value}
                onChange={(val) => onChange(val.value)}
                textField="label"
                valueField="value"
              />
            )}
          />
          <ErrorMessage>{errors.invoiceRequestType?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderInvoiceInfoUploadPath = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">
            Invoice Info Upload Path
          </label>
          <Controller
            control={control}
            rules={{
              required: 'Invoice Info upload path is required',
            }}
            name="invoiceInfoUploadPath"
            defaultValue={props.data?.invoiceInfoUploadPath}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="invoice Info Upload Path"
                name={name}
                value={value}
                onChange={onChange}
                id="invoiceInfoUploadPath"
              />
            )}
          />
          <ErrorMessage>{errors.invoiceInfoUploadPath?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderCompanyCode = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Company Code</label>
          <Controller
            control={control}
            name="companyCode"
            defaultValue={props.data?.companyCode}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Company Code"
                name={name}
                value={value}
                onChange={onChange}
                id="companyCode"
              />
            )}
          />
          <ErrorMessage>{errors.companyCode?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderButton = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3 text-right pt-3">
          <button
            type="button"
            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
            onClick={props.onCancel}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
            disabled={props.isSubmitting}
          >
            Update
          </button>
        </div>
      </div>
    );
  };

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <div className="p-4">
        <h4 className="mb-3 font-weight-semibold">Update One Drive Settings</h4>
        <div className="row gutter-10">
          {renderTenantId()}
          {renderClientId()}
          {renderClientSecret()}
          {renderUserEmail()}
          {renderOrderInfoPath()}
          {renderAccessoriesInfoPath()}
          {renderPaymentInfoPath()}
          {renderVehicleFileUploadPath()}
          {renderPaymentRequestType()}
          {renderInvoiceInfoUploadPath()}
          {renderInvoiceRequestType()}
          {renderCompanyCode()}
          <ErrorMessage>{props.error}</ErrorMessage>
          {renderButton()}
        </div>
      </div>
    </form>
  );
};

export default UpdateForm;
